module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"year":"Year","month":"Month","day":"Day"},"es":{"year":"Año","month":"Mes","day":"Día"},"sw":{"year":"Mwaka","month":"Mwezi","day":"Siku"}}')
  delete Component.options._Ctor
}
